import React from "react";
import {
    Dimensions,
    StyleSheet,
    View
} from "react-native";

import {
  getFocusTheme, setFocusTheme, setNotifyTheme, getOneTheme
} from "../../API/API";
import {
  BriefingTab, NetworkTab, EntityTab, ParticipantTab
} from "./SharedProfileTab"
import PostList from "../Feed/PostFeed/PostList";
import ExplorerThemeListItem from "../Explorer/ExplorerThemeListItem";
import {sortMixedData} from "../../utils/search";

const getDimensions = () => Dimensions.get('window');

class ThemeProfile {
  load(id) {
    return getOneTheme(id).then(item => {
      return getFocusTheme().then(data => {
	const focus = data[id] || {focus_enabled: false, notification_enabled: false};
	return {
	  item,
	  focus_enabled: focus.focus_enabled,
	  notification_enabled: focus.notification_enabled
	}
      });
    })
  }
  setFocus(item, focus_enabled) {
    const action = focus_enabled ? 'unset' : 'set'
    return setFocusTheme(item.id, action).then(() => !focus_enabled)
  }
  setNotification(item, notification_enabled) {
    const action = notification_enabled ? 'unset' : 'set'
    return setNotifyTheme(item.id, action).then(() => !notification_enabled)
  }
  getInfo(item){
    return {
      title: item.item,
      subtitle: "",
      description: "",
      affiliations: [],
    }
  }
  getTab(props){
    return [{
	title : 'Briefing',
	content: this._getBriefing(props),
      }, {
	title : 'Participants',
	content : this._getParticipant(props),
      }, {
	title : 'Arborescence',
	content : this._getThemeHierarchy(props),
    }]
  }
  _getBriefing(props) {
    const {navigation, route, item, type} = props;
    return <BriefingTab navigation={navigation} route={route} item={item} type={type} />
  }
  _getParticipant(props) {
    const {navigation, item, type} = props;

    const {contact_nodes, entity_nodes} = item.grid || {contact_nodes: [], entity_nodes: []};

    const contacts_with_grid = item.contacts.map(x => {
      const grid_node = contact_nodes.find(node => node.poi_contact_id == x.id);
      return {...x, type: "contact", grid_node};
    })

    const entities_with_grid = item.entities.map(x => {
      const grid_node = entity_nodes.find(node => node.poi_entity_id == x.id);
      return {...x, type: "entity", grid_node};
    })

    const participants = sortMixedData(contacts_with_grid.concat(entities_with_grid));

    return <ParticipantTab navigation={navigation} participants={participants} type={type} />
  }
  _getEntity(props) {
    const {navigation, item, type} = props;
    return <EntityTab navigation={navigation} item={item} type={type} />
  }
  _getReseau(props) {
    const { item, type, navigation } = props;
    return <NetworkTab navigation={navigation} item={item} type={type} />
  }
  _getThemeHierarchy(props) {
      const { all_themes, item, navigation } = props;

      const { width } = getDimensions();
      const styles =StyleSheet.create({
	  container: { width: width }
      });

      let root_id = item.root || item.subroot || item.id;
      const [ root ] = all_themes.filter(root => root.id == root_id);

      const navigateToEntityScreen = (item) => {
	navigation.navigate("EntityScreen", {id: item.id, type: "theme"});
      }

      // didn't load yet
      if (all_themes.length == 0) {
	console.log("Warning: ThemeProfile, all_themes hasn't been loaded yet");
	return <View style={styles.container} />
      }

      return <View style={styles.container}>
	  <ExplorerThemeListItem
	      navigateToEntityScreen={navigateToEntityScreen}
	      isUpdate={false}
	      focusList={[item]}
	      focusListSet={[]}
	      focusListUnSet={[]}
	      setFocusList = {() => {}}
	      isFocus={false}
	      isFocused={false}
	      item={root} />
      </View>
  }
}

export default ThemeProfile;
